'use client';

var SCRIPT_TIKTOK_EMBED_ID = 'tiktok-embed-script';
var CDN_TIKTOK_EMBED = 'https://www.tiktok.com/embed.js';

export { CDN_TIKTOK_EMBED, SCRIPT_TIKTOK_EMBED_ID };
//# sourceMappingURL=const.js.map
